import { addMonths, format, startOfMonth } from 'date-fns'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { InfoIcon } from '@/components/icons'
import { SubscriptionUsageIcon } from '@/components/icons/new'
import { SUBSCRIPTION_PLANS } from '../config'
import { SUBSCRIPTION_CREATIVE } from '../constants'

const creativePlan = SUBSCRIPTION_PLANS.find((p) => p.id === SUBSCRIPTION_CREATIVE)

const CreativesUsageRow = ({ used, purchased, isLegacy = false }) => {
    if (isLegacy) {
        return (
            <div className="tw:text-sm tw:text-[#97AFCD]">
                This license predates the subscription model — no usage limit applies.
            </div>
        )
    }

    if (purchased == null) return null

    const safePurchased = purchased || 0
    const safeUsed = used || 0
    const percent = safePurchased > 0 ? Math.min(100, Math.round((safeUsed / safePurchased) * 100)) : 0
    const resetDate = format(addMonths(startOfMonth(new Date()), 1), 'dd/MM/yyyy')

    return (
        <div className="tw:flex tw:items-center tw:gap-6">
            <div className="tw:flex tw:items-center tw:gap-2 tw:min-w-0">
                <div
                    className="tw:flex tw:items-center tw:justify-center tw:size-10 tw:rounded-full tw:shrink-0"
                    style={{
                        backgroundColor: creativePlan?.iconBg ?? '#301D57',
                    }}
                >
                    <SubscriptionUsageIcon
                        size={24}
                        color={creativePlan?.iconColor ?? '#9F7AEA'}
                        aria-hidden
                    />
                </div>
                <div className="tw:flex tw:flex-col tw:w-[180px] tw:shrink-0">
                    <div className="tw:flex tw:items-center tw:gap-1">
                        <span className="tw:text-white tw:font-semibold tw:text-base">Ads per month</span>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <button
                                    type="button"
                                    className="tw:inline-flex tw:items-center tw:justify-center tw:text-[#97AFCD] hover:tw:text-white"
                                    aria-label="Ads per month help"
                                >
                                    <InfoIcon className="tw:size-5 tw:shrink-0" />
                                </button>
                            </TooltipTrigger>
                            <TooltipContent className="tw:max-w-xs">
                                Number of ad creatives included in your plan for the current billing period.
                            </TooltipContent>
                        </Tooltip>
                    </div>
                    <span className="tw:text-sm tw:text-[#899CBD]">Resets {resetDate}</span>
                </div>
            </div>

            <div className="tw:flex tw:flex-col tw:gap-1.5 tw:flex-1">
                <div className="tw:relative tw:h-1 tw:w-full tw:rounded-full tw:bg-[#3B5168] tw:overflow-hidden">
                    <div
                        className="tw:absolute tw:left-0 tw:top-0 tw:h-full tw:bg-[#3871FF]"
                        style={{ width: `${percent}%` }}
                    />
                </div>
                <div className="tw:flex tw:justify-between tw:text-sm tw:text-[#899CBD]">
                    <span>{safeUsed} used</span>
                    <span>{safePurchased} limit</span>
                </div>
            </div>

            <div className="tw:w-20 tw:text-right tw:text-base tw:font-semibold tw:text-[#899CBD]">{percent}%</div>
        </div>
    )
}

export default CreativesUsageRow
